// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleGroupManifest } from '@platform/core/types/modularity/IModuleGroupManifest';
import { committeeMeetingsManifest } from './committee-meetings';
import { committeeReportsManifest } from './committee-reports';
import { committeesOfTheVerkhovnaRadaManifest } from './committees-of-the-verkhovna-rada';
import { expertOpinionsManifest } from './expert-opinions';
import { hearingsManifest } from './hearings';
import { verkhovnaRadaManifest } from './verkhovna-rada';

/** Група модулів «Комітети» (Committees): 6 модулів. */
export const committeesGroup: IModuleGroupManifest = {
  key: 'committees',
  category: 'Committees',
  name: { en: 'Committees', uk: 'Комітети' },
  sort: 8,
  modules: [committeeMeetingsManifest, committeeReportsManifest, committeesOfTheVerkhovnaRadaManifest, expertOpinionsManifest, hearingsManifest, verkhovnaRadaManifest],
};
